import { render, staticRenderFns } from "./EditorHeaderHelpCenter.vue?vue&type=template&id=288b29b4&"
import script from "./EditorHeaderHelpCenter.vue?vue&type=script&lang=js&"
export * from "./EditorHeaderHelpCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports